import { takeEvery, put, delay } from 'redux-saga/effects'
import {
  types as notificationsTypes,
  INotification,
} from '../types/notifications'
import { types as groupTypes } from '../types/group'
import { types as editorsPerGroupTypes } from '../types/editorsPerGroup'
import { types as packTypes } from '../types/pack'
import { types as fileTypes } from '../types/file'
import { types as datafileTypes } from '../types/datafile'
import { types as datachartTypes } from '../types/datachart'
import { types as searchTypes } from '../types/search'
import { types as publishedSearchTypes } from '../types/publishedSearch'
import { types as mediaTypeTypes } from '../types/mediaType'
import { types as mediaTypeGroupTypes } from '../types/mediaTypeGroup'
import { types as authTypes } from '../types/auth'
import { types as capabilityTypes } from '../types/capability'
import { types as languagesTypes } from '../types/languages'
import { types as publishedGraphicTypes } from '../types/publishedGraphic'
import {
  displayNotification,
  closeNotification,
} from '../actions/notifications'
import {
  NOTIFICATION_TIMEOUT,
  ERROR_NOTIFICATION_TIMEOUT,
} from '../config/notifications'

export function* notifySuccess(action: INotification) {
  yield put(displayNotification(action.message))
  yield delay(NOTIFICATION_TIMEOUT)
  yield put(closeNotification())
}

export function* notifyError(action: INotification) {
  yield put(displayNotification(action.message, action.correlationId))
  yield delay(ERROR_NOTIFICATION_TIMEOUT)
  yield put(closeNotification())
}

export function* notificationsWatcher() {
  yield takeEvery(notificationsTypes.NOTIFICATION_TRIGGER, notifySuccess)
  yield takeEvery(groupTypes.CREATE_GROUP__FAILURE, notifyError)
  yield takeEvery(groupTypes.CREATE_GROUP__SUCCESS, notifySuccess)
  yield takeEvery(groupTypes.UPDATE_GROUP__FAILURE, notifyError)
  yield takeEvery(groupTypes.UPDATE_GROUP__SUCCESS, notifySuccess)
  yield takeEvery(groupTypes.DELETE_GROUP__SUCCESS, notifySuccess)
  yield takeEvery(groupTypes.GET_GROUP_BY_ID__FAILURE, notifyError)
  yield takeEvery(editorsPerGroupTypes.GET_GROUP_EDITORS__FAILURE, notifyError)
  yield takeEvery(packTypes.GET_PACK_BY_ID__FAILURE, notifyError)
  yield takeEvery(packTypes.UPDATE_PACK__FAILURE, notifyError)
  yield takeEvery(packTypes.UPDATE_PACK__SUCCESS, notifySuccess)
  yield takeEvery(packTypes.PUBLISH_PACK__FAILURE, notifyError)
  yield takeEvery(packTypes.CREATE_PACK__FAILURE, notifyError)
  yield takeEvery(packTypes.CREATE_PACK__SUCCESS, notifySuccess)
  yield takeEvery(packTypes.DELETE_FILE__FAILURE, notifyError)
  yield takeEvery(packTypes.DELETE_FILE__SUCCESS, notifySuccess)
  yield takeEvery(packTypes.DELETE_PACK__FAILURE, notifyError)
  yield takeEvery(packTypes.DELETE_PACK__SUCCESS, notifySuccess)
  yield takeEvery(fileTypes.CREATE_OR_UPDATE_EDITION__SUCCESS, notifySuccess)
  yield takeEvery(fileTypes.READ_LOCAL_FILE__CANCEL, notifyError)
  // Media Type
  yield takeEvery(mediaTypeTypes.CREATE_MEDIA_TYPE__FAILURE, notifyError)
  yield takeEvery(mediaTypeTypes.CREATE_MEDIA_TYPE__SUCCESS, notifySuccess)
  yield takeEvery(mediaTypeTypes.UPDATE_MEDIA_TYPE__FAILURE, notifyError)
  yield takeEvery(mediaTypeTypes.UPDATE_MEDIA_TYPE__SUCCESS, notifySuccess)
  // Media Type Group
  yield takeEvery(
    mediaTypeGroupTypes.CREATE_MEDIA_TYPE_GROUP__FAILURE,
    notifyError
  )
  yield takeEvery(
    mediaTypeGroupTypes.CREATE_MEDIA_TYPE_GROUP__SUCCESS,
    notifySuccess
  )
  yield takeEvery(
    mediaTypeGroupTypes.UPDATE_MEDIA_TYPE_GROUP__FAILURE,
    notifyError
  )
  yield takeEvery(
    mediaTypeGroupTypes.UPDATE_MEDIA_TYPE_GROUP__SUCCESS,
    notifySuccess
  )
  yield takeEvery(
    mediaTypeGroupTypes.GET_MEDIA_TYPE_GROUP_BY_ID__FAILURE,
    notifyError
  )
  yield takeEvery(mediaTypeTypes.GET_MEDIA_TYPE_BY_ID__FAILURE, notifyError)
  yield takeEvery(mediaTypeTypes.DELETE_MEDIA_TYPE__SUCCESS, notifySuccess)
  yield takeEvery(
    mediaTypeGroupTypes.DELETE_MEDIA_TYPE_GROUP__SUCCESS,
    notifySuccess
  )
  yield takeEvery(datafileTypes.CREATE_DATAFILE__FAILURE, notifyError)
  yield takeEvery(datafileTypes.CREATE_DATAFILE__SUCCESS, notifySuccess)
  yield takeEvery(datafileTypes.UPDATE_DATAFILE__FAILURE, notifyError)
  yield takeEvery(datafileTypes.UPDATE_DATAFILE__SUCCESS, notifySuccess)
  yield takeEvery(datachartTypes.CREATE_DATACHART__SUCCESS, notifySuccess)
  yield takeEvery(datachartTypes.CREATE_DATACHART__FAILURE, notifyError)
  yield takeEvery(searchTypes.SEARCH_PACKS__FAILURE, notifyError)
  yield takeEvery(
    publishedSearchTypes.PUBLISHED_SEARCH_PACKS__FAILURE,
    notifyError
  )
  yield takeEvery(authTypes.AUTH_FAILURE, notifyError)

  // Capablity
  yield takeEvery(capabilityTypes.CREATE_CAPABILITY__SUCCESS, notifySuccess)
  yield takeEvery(capabilityTypes.CREATE_CAPABILITY__FAILURE, notifyError)
  yield takeEvery(capabilityTypes.UPDATE_CAPABILITY__SUCCESS, notifySuccess)
  yield takeEvery(capabilityTypes.UPDATE_CAPABILITY__FAILURE, notifyError)
  yield takeEvery(languagesTypes.GET_LANGUAGES__FAILURE, notifyError)
  yield takeEvery(capabilityTypes.GET_CAPABILITY_BY_ID__FAILURE, notifyError)
  yield takeEvery(capabilityTypes.DELETE_CAPABILITY__SUCCESS, notifySuccess)

  // Published graphics
  yield takeEvery(
    publishedGraphicTypes.GET_PUBLISHED_GRAPHIC_BY_ID__FAILURE,
    notifyError
  )
}
